import { axios } from "../utils/request";

// 1.1.1.1 获取验证码
export function sendLoginVerificationCode(data) {
  return axios({
    url: '/h5Login/sendLoginVerificationCode',
    method: 'post',
    data
  })
}

// 1.1.1.2 登录
export function loginByTel(data) {
  return axios({
    url: '/h5Login/loginByTel',
    method: 'post',
    data
  })
}


// 1.1.1.3 获取用户信息
export function getUserInfo(data) {
  return axios({
    url: '/h5Login/getUserInfo',
    method: 'post',
    data
  })
}

// 3010105 用户认证
export function userAuth(data) {
  return axios({
    url: '/h5Login/userAuth',
    method: 'post',
    data
  })
}
